import type { InterestZoneRun, InterestZoneRunParams } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const startInterestZoneRun = async (
  params: InterestZoneRunParams,
): Promise<InterestZoneRun> => {
  const { data } = await gozokiApiWithAuth.post<InterestZoneRun>('/interest-zone-runs', params)
  return data
}
